import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RestaurantProvider } from './contexts/RestaurantContext.tsx';
import { ReservationProvider } from './contexts/ReservationContext.tsx';
import PublicLayout from './layouts/PublicLayout.tsx';
import PublicReservation from './pages/public/PublicReservation.tsx';
import { getPublicReservoSettings } from '../../../services/publicReservoApi';

const PublicReservoWrapper: React.FC = () => {
  const { slug_restaurante } = useParams<{ slug_restaurante: string }>();
  const [checkingSettings, setCheckingSettings] = useState(true);
  const [reservationsEnabled, setReservationsEnabled] = useState(true);

  useEffect(() => {
    let active = true;

    const loadSettings = async () => {
      if (!slug_restaurante) {
        setCheckingSettings(false);
        return;
      }

      try {
        const settings = await getPublicReservoSettings(slug_restaurante);
        if (active) {
          setReservationsEnabled(settings?.reservo_usar_reservas !== false);
        }
      } catch (error) {
        if (active) {
          setReservationsEnabled(false);
        }
      } finally {
        if (active) {
          setCheckingSettings(false);
        }
      }
    };

    loadSettings();

    return () => {
      active = false;
    };
  }, [slug_restaurante]);

  if (checkingSettings) {
    return (
      <PublicLayout>
        <div className="loading">Carregando reservas...</div>
      </PublicLayout>
    );
  }

  if (!reservationsEnabled) {
    return (
      <PublicLayout>
        <div className="loading">A página pública de reservas está indisponível neste momento.</div>
      </PublicLayout>
    );
  }

  return (
    <RestaurantProvider isPublic={true} slug={slug_restaurante}>
      <ReservationProvider isPublic={true} slug={slug_restaurante}>
        <PublicLayout>
          <PublicReservation />
        </PublicLayout>
      </ReservationProvider>
    </RestaurantProvider>
  );
};

export default PublicReservoWrapper;
